export const HOST_NAME = "https://admin.innerviewit.com";
export const CLIENT_HOST_NAME = "https://www.innerviewit.com"
export const API_ROUTES = {
  getCategory: "/api/category",
  getExperience: "/api/experience/mainList",
  getExperienceDetail: "/api/experience/detailDesc",

  getMain: "/api/home/mainList",
  getBadge: "/api/about/badgeList",

  getLocation: "/api/contact/location",

  getService: "/api/request/serviceList",
  getProject: "/api/request/projectList",
  getHowToKnow: "/api/request/howToKnowList",
  getSend: "/api/request/send",

  getHiring: "/api/recruit/hiringList",

  postApplySend: "/api/apply/send",
  postRequestSend: "/api/request/send",
  downloadBrochure: "/api/download/brochure",

  letterSubscribe: "/api/subscribe", // 구독 관련
};

export const COMPANY_LOGO = "/img/iv_logo.svg";

export const LOCATION_MARKER = "/img/location_marker.png";

export const MOBILE_WIDTH = 750;
export const TABLET_WIDTH = 1100;

export const INPUT_HEIGHT = '6rem';
export const INPUT_HEIGHT_MOBILE = '59px';

export const SCROLL_DURATION = 1200;
export const SCROLL_DELAY = 100;
export const SCROLL_OFFSET = 200;

export const CompanyInfoObj = {
  address: '서울시 구로구 디지털로 306 대륭포스트타워 2차 608호',
  tel: '070 . 4610 . 3570',
  email: 'sammrina@innerviewit.com',
  howto: '-'
};
